import { apiFetch } from "./apiFetch";

function query(params) {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      search.set(key, value);
    }
  });
  const suffix = search.toString();
  return suffix ? `?${suffix}` : "";
}

export function fetchNudgeAuditUsers(params) {
  return apiFetch(`/admin/nudges/users/${query(params)}`);
}

export function fetchNudgeAudit(params) {
  return apiFetch(`/admin/nudges/audit/${query(params)}`);
}

export function runNudgeAudit(params) {
  return apiFetch(`/admin/nudges/audit/`, {
    method: "POST",
    body: JSON.stringify(params || {}),
  });
}

export function fetchNudgeRuns(params) {
  return apiFetch(`/admin/nudges/runs/${query(params)}`);
}

export function fetchCoachCommunications(params) {
  return apiFetch(`/admin/nudges/communications/${query(params)}`);
}

export function fetchCoachCommunicationSummary(params) {
  return apiFetch(`/admin/nudges/communications/summary/${query(params)}`);
}
